import { render } from "./InputBar.vue?vue&type=template&id=b99f6018"
import script from "./InputBar.vue?vue&type=script&lang=js"
export * from "./InputBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__